import { forwardRef, useEffect } from 'react';
import StateController from '../components/statecontroller';
import WizardStateContext from '../context/wizardstate';
import trend from './images/trend.png';
import summary from './images/summary.png';
import summary_historical from './images/summary_historical.png';
import BottomScrollPosition from './BottomScrollPosition';

const Wizard = forwardRef((props, ref) => {
  const {
    children,
    canAutoScroll = true,
    setCanAutoScroll,
    modalBody,
    isEditing,
    isGenerating,
    setIsGenerating,
    ...rest
  } = props;

  // Preload the chart selector images so we don't get odd
  // UI state while they're loading
  useEffect(() => {
    [trend, summary, summary_historical].forEach((url) => {
      const img = new Image();
      img.src = url;
    });
  }, []);

  return (
    <WizardStateContext.Wrapper
      {...rest}
      ref={ref}
      isGenerating={isGenerating}
      setIsGenerating={setIsGenerating}
    >
      <StateController isEditing={isEditing}>{children}</StateController>
      <BottomScrollPosition
        canAutoScroll={canAutoScroll}
        setCanAutoScroll={setCanAutoScroll}
        modalBody={modalBody}
      />
    </WizardStateContext.Wrapper>
  );
});
export default Wizard;
